<template>
<div class="address">
    <div class="s-address" v-if="defaultAddress" @click="showAddressList">
        <div class="info">
			<img class="address-icon" src="../../assets/dizhi_icon.png" alt="">
            <div>
				<p>
                <span class="bold">{{defaultAddress.receiver}}</span>
                <span class="bold">{{defaultAddress.telephone}}</span>
            </p>
            	<p>{{defaultAddress.area + defaultAddress.detail}}</p>
			</div>
        </div>
        <img class="right-icon" src="../../assets/r_icon.png" alt="">
        <!-- <img class="bottom-line" src="../../assets/icon-address-bg.png" alt=""> -->

    </div>
    <div class="add-address" v-else>
        <button class="change-btn" @click="showAddAddress()">
            <div>
				<Icon class="icon" :img="require('../../assets/dizhi_icon.png')" size="contain"/>
            	<span>暂无地址，点击新增收货地址</span>
			</div>
			<Icon class="icon right" :img="require('../../assets/r_icon.png')" size="contain"/>
        </button>
    </div>
    <UserAddress ref="addressList" :address="address" :curr="curr"  @onAddressChange="setCurrAddress" @onAddAddress="showAddAddress" @onAddressReload="onAddressReload"/>
    <AddUserAddress ref="addAddress" @onAddressReload="onAddressReload"/>

</div>
</template>
<script>
import AddUserAddress from '@/components/products/form/AddUserAddress'
import UserAddress from '@/components/products/form/UserAddress'

export default {
    props: ['address','defaultAddress'],
    components: {
        AddUserAddress,
        UserAddress
    },
    data() {
        return {
            curr: this.address.length > 0 ? this.address[0] : null,
        }
    },
    methods: {
		
        showAddressList(){
            this.$refs.addressList.showAddressList();
        },
        showAddAddress() {
            this.$refs.addAddress.show();
        },
        setCurrAddress(address){
            this.curr = address;
            this.$emit('onAddressSelected', address);
        },
        onAddressReload(){
            this.$refs.addressList.closeAddressList();
            this.$emit('onAddressReload');
        }
	},
}
</script>
<style scoped lang="less">
p {
	margin: 0;
}

.add-address {
    background: #fff;
    text-align: center;
}
.info {
	display: flex;
	align-items: center;
	.address-icon {
		height: 4.8vw;
		margin-right: 2.67vw;
	}
}
.info p:first-child {
    color: #404040;
}

.info p:last-child {
	font-size: 3.47vw;
	color: #999;
	margin-top: 1.2vw;
}

.s-address {
	height: 21.13vw;
    position: relative;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
	display: flex;
	color: #ccc;
    justify-content: space-between;
    align-items: center;
	padding: 0 2.67vw 0.2vw 2.67vw;
	background-image: url('../../assets/dizhilan_bgimg.png');
    .bold {
        // font-weight: bold;
        font-size: 4vw
    }
    .bold:first-child {
        margin-right: 6.13333333vw
    }
}

.change-btn {
	width: 100%;
	height: 21.33vw;
    @size: 4vw;
    background-image: url('../../assets/dizhilan_bgimg.png');
    border: none;
    color: #3c3c3c;
    font-size: 4vw;
    display: flex;
	vertical-align: middle;
	align-items: center;
	justify-content: space-between;
	padding: 0 2.67vw;
    .icon {
        width: 3.47vw;
        height: 4.8vw;
		margin-right: 1.1vw;
		margin-top: -0.5vw;
		display: inline-block;
	}
	.right {
		width: 1.6vw;
		height: 2.67vw;
		margin-right: 0;
	}
    span{
        vertical-align: top;
        display: inline-block;
        line-height: 1em;
    }
}

.right-icon {
    height: 2.67vw;
}

.bottom-line {
    height: 1.5vw;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/payment/address.vue